import React from 'react'

import Paper from 'material-ui/Paper';

import NewTelephoneNumber from '../../../../components/telephone/NewTelephoneNumber';
import TelephoneDirectoryList from '../../../../components/telephone/TelephoneDirectoryList';

import { directory as ROLES_CONFIG } from '../../../../config/roles';

export default class TelephoneDirectory extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      role: this.props.authenticated ? this.props.authenticated.role : null
    }
  }

  render() {
    return (
      <div id="content">
        <div className="row">
          {
            ROLES_CONFIG.newNumber.indexOf(this.state.role) != -1 ?
              <Paper className="col-sm-5 col-11 ml-3vw mt-1vw p-0 h-100 customShadow" zDepth={3}>
                <NewTelephoneNumber />
              </Paper> 
            : null
          }
          {
            ROLES_CONFIG.directoryList.indexOf(this.state.role) != -1 ?
              <Paper className="col-sm-6 col-12 ml-2vw mt-1vw p-0 h-100 customShadow" zDepth={3}>
                <TelephoneDirectoryList />
              </Paper> 
            : null
          }
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./routes/app/routes/Telephone/TelephoneDirectory.js